import {
  Button,
  Divider,
  Menu,
  MenuItem,
  Popover,
  Card,
} from '@blueprintjs/core';
import { comment } from '@axo/shared/data-access/types';
import {
  CreatorTag,
  CommentIcon,
  CreatedAtTag,
  FollowupTag,
} from '../CommunicationItem';
import cardClasses from '../CommunicationItem/Card.module.css';

interface ICommentCardView {
  comment: comment.Comment;
  removeComment: () => void;
  setEditComment: () => void;
  markAsResolved: () => void;
}

export function CommentCardView({
  comment,
  removeComment,
  setEditComment,
  markAsResolved,
}: ICommentCardView) {
  return (
    <Card className={cardClasses.card}>
      <div className={cardClasses.topBar}>
        <CommentIcon />
        <CreatorTag creatorID={comment.OwnerID} />
        <CreatedAtTag label="Commented at:" createdAt={comment.CreatedAt} />
        <div className={cardClasses.fill} />
      </div>
      <Divider />
      <div className={cardClasses.body}>
        <div>{comment.Body}</div>
      </div>
      <div className={cardClasses.bottomRow}>
        <FollowupTag
          followupAt={comment.FollowupAt}
          resolvedAt={comment.ResolvedAt}
        />
        <div className={cardClasses.fill} />
        <Popover
          interactionKind="hover"
          content={
            <Menu>
              <MenuItem text="Delete comment" onClick={removeComment} />
              <MenuItem text="Edit comment" onClick={setEditComment} />
              {comment.FollowupAt && !comment.ResolvedAt && (
                <MenuItem text="Mark as resolved" onClick={markAsResolved} />
              )}
            </Menu>
          }
        >
          <Button minimal icon="more" />
        </Popover>
      </div>
    </Card>
  );
}
